module.exports = __webpack_public_path__ + "static/media/slots.edcc88ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/slots.jpg
// module id = 2407
// module chunks = 7